import { render } from "./PanelProjects.vue?vue&type=template&id=1a2324aa"
const script = {}

import "./PanelProjects.vue?vue&type=style&index=0&id=1a2324aa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__